import React from 'react';
import styles from './PostNotificationBadge.module.css';
import { useGetUnreadCountQuery } from '../store/api/notificationApi';

export default function PostNotificationBadge() {

  const { data: unreadCount = 0 } =
    useGetUnreadCountQuery();

  if (!unreadCount) return null;

  return (
    <span className={styles.badge}>
      {unreadCount > 99 ? '99+' : unreadCount}
    </span>
  );
}
